import { Phone, Mail, MapPin } from "lucide-react";
import { CONTACT_INFO } from "@/constants/site";

export default function Contact() {
    return (
        <main
            data-testid="contact-page"
            className="relative min-h-[100svh] bg-rz-bg px-6 md:px-12 pt-32 pb-24"
        >
            <div className="mx-auto max-w-[1400px]">
                <span className="text-xs tracking-[0.22em] uppercase text-rz-sage font-semibold">
                    Contact
                </span>
                <h1 className="font-display mt-5 max-w-3xl text-[clamp(2.4rem,6vw,4.5rem)] font-extrabold tracking-tighter leading-[1] text-rz-ink">
                    Parlons de votre projet.
                </h1>
                <p className="mt-6 max-w-xl text-base lg:text-lg leading-relaxed text-rz-ink-soft">
                    Une exploitation, un haras, un projet solaire ? Contactez-nous, nous sommes là
                    pour vous accompagner partout en France.
                </p>

                <div className="mt-14 grid gap-5 md:grid-cols-3">
                    {[
                        { icon: Phone, label: "Téléphone", value: CONTACT_INFO.phone, href: `tel:${CONTACT_INFO.phone.replace(/\s/g, "")}` },
                        { icon: Mail, label: "Email", value: CONTACT_INFO.email, href: `mailto:${CONTACT_INFO.email}` },
                        { icon: MapPin, label: "Zone d'intervention", value: CONTACT_INFO.zone, href: null },
                    ].map((c) => {
                        const inner = (
                            <>
                                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-rz-pale/40 text-rz-green">
                                    <c.icon size={22} />
                                </span>
                                <p className="mt-5 text-xs tracking-[0.18em] uppercase text-rz-ink-soft">
                                    {c.label}
                                </p>
                                <p className="mt-2 font-display text-lg font-bold text-rz-ink">
                                    {c.value}
                                </p>
                            </>
                        );
                        return c.href ? (
                            <a
                                key={c.label}
                                href={c.href}
                                data-testid={`contact-card-${c.label}`}
                                className="rounded-2xl border border-black/5 bg-white p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
                            >
                                {inner}
                            </a>
                        ) : (
                            <div
                                key={c.label}
                                data-testid={`contact-card-${c.label}`}
                                className="rounded-2xl border border-black/5 bg-white p-8"
                            >
                                {inner}
                            </div>
                        );
                    })}
                </div>
            </div>
        </main>
    );
}
